export default __webpack_public_path__ + "icon_calendar_2.62a95e5fba8c8af0f63b594a1e8db234.svg";